import { BorderWidthAll } from '../../themes/default/borderWidth/index.js';
import { BorderWidthTokensAll } from '../../themes/default/borderWidth/borderWidth-tokens.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var themeBorderWidth = function themeBorderWidth() {
  var borderWidthOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var themedBorderWidth = _objectSpread({}, BorderWidthAll);

  var keys = Object.keys(borderWidthOverrides);
  keys.forEach(function (borderWidthName) {
    if (Object.keys(BorderWidthTokensAll).indexOf(borderWidthName) === -1) {
      if (typeof borderWidthOverrides[borderWidthName] === 'number') {
        themedBorderWidth[borderWidthName] = borderWidthOverrides[borderWidthName];
      } else {
        /* eslint-disable no-console */
        console.error("Border Width override must be a number or one of the values in BorderWidth Tokens - ignoring ".concat(borderWidthName, " override"));
      }
    } else {
      console.error("User may not override Border Width Tokens: ".concat(Object.keys(BorderWidthTokensAll), " - ignoring ").concat(borderWidthName, " override"));
    }
  });
  return themedBorderWidth;
};

export { themeBorderWidth };
